/* Icon placeholder shown when a feed item has no thumbnail image. */

import { MonitorPlay, FileText, Podcast, Clapperboard, Mail, BookOpen, Film, ListVideo, Globe } from "lucide-react";
import { cn } from "@/lib/utils";

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  video: MonitorPlay,
  article: FileText,
  podcast: Podcast,
  reel: Clapperboard,
  email: Mail,
  book: BookOpen,
  movie: Film,
  playlist: ListVideo,
};

interface ThumbnailPlaceholderProps {
  contentType?: string;
  className?: string;
}

export function ThumbnailPlaceholder({ contentType, className = "rounded-sm" }: ThumbnailPlaceholderProps) {
  const Icon = (contentType && ICON_MAP[contentType]) || Globe;

  return (
    <div className={cn("w-full h-full bg-muted flex items-center justify-center", className)}>
      <Icon className="size-6 text-muted-foreground/50" />
    </div>
  );
}
